<template>
  <div id="app">
    <b-container fluid v-if="loaded">
      <b-row>
        <b-col class="app-logo-box"
            cols="12" sm="12" md="4" lg="4" xl="4"
            order="1" order-sm="1" order-md="1" order-lg="1" order-xl="1">
          <img :src="institutionLogo" :v-if="institutionLogo!=''" class="logo-image" />
        </b-col>

        <b-col class="app-title-box" 
            cols="12" sm="12" md="4" lg="4" xl="4" 
            order="3" order-sm="3" order-md="2" order-lg="2" order-xl="2">
          <p v-show="accessionNumber == ''">Dermatology Consult Request</p>
        </b-col>

        <b-col class="app-inst-box"
            cols="12" sm="12" md="4" lg="4" xl="4"
            order="2" order-sm="2" order-md="3" order-lg="3" order-xl="3">
          <div class="inst-name">{{institutionName}}</div>
          <div class="inst-address">{{institutionAddress}}</div>
        </b-col>
      </b-row>
    </b-container>

    <router-view v-if="loaded" />

    <div v-if="!loaded && loadError==''">
      Loading, please wait...
    </div>

    <div v-if="loadError!=''">
      {{loadError}}
      <br />
      <b-button onclick="window.location.reload()">
        Retry
      </b-button>
    </div>

    <div class="text-right m-3">
      Powered by <b-link href="https://www.medweb.com">Medweb</b-link>
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
// import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

// imports
import { BContainer,
    BRow,
    BCol,

    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormSelectOption,
    BFormRadioGroup,
    BFormRadio,
    BFormCheckboxGroup,

    BModal,
    BButton,
    BCollapse,
    BCard,
    BCardBody,
    BCardHeader,
    BLink,

    // directive
    VBToggle,
  } from 'bootstrap-vue'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import {debug, makeUrl, parseNetworkError} from '@/components/globals.js'

// components
Vue.component('b-container', BContainer);
Vue.component('b-row', BRow);
Vue.component('b-col', BCol);

Vue.component('b-form-group', BFormGroup)
Vue.component('b-form-input', BFormInput);
Vue.component('b-form-select', BFormSelect);
Vue.component('b-form-select-option', BFormSelectOption);
Vue.component('b-form-radio-group', BFormRadioGroup);
Vue.component('b-form-radio', BFormRadio);
Vue.component('b-form-checkbox-group', BFormCheckboxGroup);

Vue.component('b-modal', BModal);
Vue.component('b-button', BButton);

Vue.component('b-collapse', BCollapse);
Vue.component('b-card', BCard);
Vue.component('b-card-body', BCardBody);
Vue.component('b-card-header', BCardHeader);
Vue.component('b-link', BLink);

Vue.directive('b-toggle', VBToggle);




export default {
  name: 'app',

  data() {
    return {
      loaded: false,
      loadError: ''
    }
  },


  computed: {
    institutionLogo: function() {
      return this.$store.getters['config/institutionLogo']
        ? makeUrl(this.$store.getters['config/institutionLogo']) : ''
    },

    institutionName: function() {
      return this.$store.getters['config/institutionName']
    },

    institutionAddress: function() {
      return this.$store.getters['config/institutionAddress']
    },

    consultUid: function() {
      return this.$store.getters['config/consultUid']
    },

    accessionNumber() {
      return this.$store.getters['form/accessionNumber'] // use the form store!!!
    },
  },


  mounted() {
    debug('App mounted');


    this.$store.dispatch('config/loadConfig')
      .then(() => {
        debug('App mounted: config/loadConfig returned OK');

        // copy consult UID to the form store
        this.$store.dispatch('form/setConsultUid', this.consultUid);

        this.loaded = true
      }, error => {
        debug('App mounted: config/loadConfig error: ' + error.message)
        const parsedError = parseNetworkError(error);
        this.loadError = 'Cannot load the app configuration. ' + parsedError.text;
      });
  },
}
</script>


<style>

@import './assets/css/app.css';

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}


.app-logo-box {
  text-align: left;
  padding: 5px;
}

.app-title-box {
  font-size: 2em;
}

.app-inst-box {
  text-align: right;
}

.inst-name {
  font-size: 1.2em;
  font-weight: bold;
}

.inst-address {
  font-size: 0.8em;
}


/* narrow screen */
@media (max-width: 767px) {
  .app-logo-box {
    text-align: center;
  }

  .app-title-box {
    font-size: 1.2em;
    font-weight: bold;
  }

  .app-inst-box {
    text-align: center;
  }

  .inst-name {
    font-size: 1em;
    font-weight: bold;
  }

  .inst-address {
    font-size: 0.8em;
  }

}



.logo-image {
  max-height: 40px;
  /* position: absolute;
  left: 5px;
  top: 5px; */
}



.b1 {
  border: thin solid blue;
}
</style>
